import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const TaxWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-top: 1px solid #2a2a2a;
  margin: 20px 0 37px;
  padding-top: 20px;
`;

export const TaxTitle = styled.span`
  display: block;
  color: #585a5f;
  font-size: 12px;
  line-height: 22px;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }
`;

export const TaxTotal = styled.span`
  display: flex;
  align-items: center;
  color: #000;
  font-size: 15px;
  line-height: 22px;

  @media ${minBp('tablet')} {
    font-size: 17px;
  }

  @media ${minBp('desktop')} {
    font-size: 22px;
  }
`;

export const InfoCircleWrap = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    position: relative;
    top: 2px;
  }

  svg {
    height: 16px;
    width: 16px;
    padding-bottom: 2px;

    @media ${minBp('tabletLarge')} {
      height: 28px;
      width: 24px;
    }

    path {
      fill: #000;
    }
  }
`;
